module.exports = __webpack_public_path__ + "img/nrg.259d3e51.svg";